import React from 'react';
import axios from 'axios';
import Tooltip from '@/components/common/Tooltip';
import cn from '@/utils/cn';
import { queryClient } from '../../../GradesTableQueryClientProvider';

export interface ClearAllButtonsProps {
  afterReset?: () => void;
  assignmentType?: 'lesson game' | 'assessment';
  isDisabled?: boolean;
  link: string;
  queryKey: any[];
}

const ClearAllButton = ({
  afterReset,
  assignmentType = 'assessment',
  isDisabled = true,
  link,
  queryKey,
}: ClearAllButtonsProps) => {
  const reset = () => {
    axios
      .post(link)
      .then(() => {
        queryClient.invalidateQueries({
          exact: true,
          queryKey,
          refetchType: 'active',
        });
        if (afterReset) afterReset();
      });
  };

  return (
    <Tooltip
      content="There is no student work to clear."
      delay={750}
      interactive={false}
      shouldDisplay={isDisabled}
      size="medium"
      theme="white"
    >
      <span>
        <button
          aria-disabled={isDisabled}
          aria-label={`Clear all ${assignmentType} scores`}
          className="tw-w-full dropdown-item tw-px-6"
          data-confirm={`This action will delete this classroom's ${assignmentType} results. Are you sure?`}
          disabled={isDisabled}
          id={`reset_class_${assignmentType}_scores`}
          type="button"
          onClick={reset}
        >
          <i className={cn('fa fa-trash-o tw-text-red', { 'tw-text-inherit': isDisabled })} />
          Clear All
        </button>
      </span>
    </Tooltip>
  );
};

export default ClearAllButton;
